const styles = {
  tooltipContainerStyle: { width: "264px", fontSize: "1.3rem" },
  updatedTooltipContainerStyle: { width: "248px" },
};

export default styles;
